import React from 'react';
import Navbar from '../components/Navbar';
import SEOHead from '../components/SEOHead';

const Glossary = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-950">
      <SEOHead
        fullTitle="Cybersecurity & Typosquatting Glossary | TypoGuard"
        description="Learn the key terms of domain security: typosquatting, homograph attacks, phishing, punycode, and more."
      />
      
      <Navbar />

      <div className="pt-24 pb-16 px-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-5xl mb-6 text-center">
            Cybersecurity Glossary
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 text-center mb-12">
            Essential terms to understand domain security and digital brand protection.
          </p>

          <div className="space-y-8">
            <div className="bg-white dark:bg-dark-800 rounded-2xl p-8 shadow-sm border border-gray-200 dark:border-dark-600">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Typosquatting</h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                Also known as URL hijacking, a sting site, or a fake URL, typosquatting is a form of cybersquatting which relies on mistakes such as typographical errors made by Internet users when inputting a website address into a web browser. Hackers register domains similar to popular sites to intercept traffic.
              </p>
            </div>

            <div className="bg-white dark:bg-dark-800 rounded-2xl p-8 shadow-sm border border-gray-200 dark:border-dark-600">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Homograph Attack (Homoglyph)</h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                A spoofing attack where an attacker registers a domain name that looks visually identical to a legitimate domain, but uses different characters (e.g., replacing a Latin 'a' with a Cyrillic 'а'). These are highly effective for phishing campaigns as they often bypass human visual inspection.
              </p>
            </div>

            <div className="bg-white dark:bg-dark-800 rounded-2xl p-8 shadow-sm border border-gray-200 dark:border-dark-600">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Phishing</h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                A cyber attack that uses disguised email or websites as a weapon. The goal is to trick the recipient into believing that the message is something they want or need, leading them to click a malicious link or provide sensitive information like passwords.
              </p>
            </div>

            <div className="bg-white dark:bg-dark-800 rounded-2xl p-8 shadow-sm border border-gray-200 dark:border-dark-600">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Punycode</h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                An encoding scheme used to convert Unicode characters to ASCII. It allows Internationalized Domain Names (IDNs) to be used. Attackers exploit Punycode to register domains that look like familiar names but are technically different strings (e.g., "xn--m1a.com" rendering as an IDN).
              </p>
            </div>

            <div className="bg-white dark:bg-dark-800 rounded-2xl p-8 shadow-sm border border-gray-200 dark:border-dark-600">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">TLD (Top-Level Domain)</h2>
              <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                The last segment of a domain name, located after the last dot (e.g., .com, .org, .net). A common attack vector is TLD swapping, where an attacker registers "yourbrand.net" when you only own "yourbrand.com".
              </p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Basic Footer */}
      <footer className="bg-gray-900 dark:bg-dark-950 py-12">
        <div className="text-center text-gray-400">
          <p>&copy; 2025 TypoGuard. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Glossary;
